import LeafRectangleLoader from "../../../../common/leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import "./ActionCardSkeleton.scss";

export const ActionCardSkeleton = () => (
  <div className="action-card-skeleton">
    <LeafRectangleLoader isLoading={true} width="50%" height="1.25rem" margin="0" />
    <hr className="action-card-skeleton__divider" />
    <LeafRectangleLoader isLoading={true} numRows={1} height="1.5rem" width="60%" margin="0" />
    <LeafRectangleLoader isLoading={true} numRows={1} height="1.5rem" width="70%" margin="0" />
  </div>
);

const ACTION_CARD_SKELETON_COUNT = 3;

export const ActionCardSkeletonList = () => (
  <>
    {Array.from({ length: ACTION_CARD_SKELETON_COUNT }, (_, i) => (
      <ActionCardSkeleton key={i} />
    ))}
  </>
);
